import React, { useEffect, useReducer } from 'react';
import { render } from 'react-dom';
import BrowserRouter from 'react-router-dom/BrowserRouter';
import { ThemeProvider } from '@material-ui/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import theme from './theme';
import App from './App';
import { isLoggedIn } from './services/useAuthentication';
import { AuthProvider } from './providers/AuthProvider';
import { MessageProvider } from './providers/MessageProvider';
import AuthReducer from './reducers/AuthReducer';
import MessageReducer from './reducers/MessageReducer';

function Main() {
  const [auth, dispatch] = useReducer(AuthReducer, { isLoggedIn });
  const [errors, dispatchMessage] = useReducer(MessageReducer, []);

  useEffect(() => {
    const jssStyles = document.querySelector('#jss-ssr');
    if (jssStyles) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider dispatch={dispatch} value={auth}>
        <MessageProvider dispatch={dispatchMessage} value={errors}>
          <MuiPickersUtilsProvider utils={MomentUtils} locale="es">
            <ThemeProvider theme={theme}>
              <App />
            </ThemeProvider>
          </MuiPickersUtilsProvider>
        </MessageProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

render(
  <Main />,
  document.getElementById('root'),
);

if (module.hot) {
  module.hot.accept();
}
